import { AccountSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryHook } from '~/shared/providers/api';

export interface AccountOption {
  id: string;
  name: string;
}

export interface AccountsForInviteQueryParams {
  searchTerm?: string;
  sorting?: AccountSortOption[];
  limit?: number;
  offset?: number;
}

export interface AccountsForInviteQueryResult {
  accounts: AccountOption[];
  total: number;
}

export const useAccountsForInviteQuery = createQueryHook(
  'settings.customerPortal.accountsForInvite',
  (params: AccountsForInviteQueryParams) => ({
    accounts: {
      __args: {
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 100,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): AccountsForInviteQueryResult => ({
      accounts:
        data?.accounts.entries.map((account) => ({
          id: account.id,
          name: account.name,
        })) ?? [],
      total: data?.accounts.page.total ?? 0,
    }),
  },
);
